<template>
  <v-container>
    <v-row justify-center>
      <v-col>
        <v-card>
          <v-app-bar color="#1B8A62">
            <v-toolbar-title style="color: white"> Cycles </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn to="cycle" style="color: #1b8a62" color="white" v-if="canManageCycles">
              <v-icon>content_paste</v-icon>
              &nbsp; Créer un cycle
            </v-btn>
          </v-app-bar>

          <div>
            <v-data-table
              :headers="headers"
              :items="cycles"
              item-key="id"
              :options.sync="options"
              :server-items-length="totalCycles"
              :footer-props="{
                'items-per-page-options': pageSizes,
              }"
              :items-per-page="pageSize"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              @click:row="emitter"
            >
              <!-- Filters params -->
              <template v-slot:[`body.prepend`]>
                <tr>
                  <td>
                    <v-text-field v-model="searchParams.id" type="number" label="Id" @input="isTyping = true" clearable @click:clear="onClearIdClicked()"></v-text-field>
                  </td>
                  <td>
                    <v-text-field
                      v-model="searchParams.name"
                      type="text"
                      label="Titre"
                      @input="isTyping = true"
                      clearable
                      @click:clear="onClearNameClicked()"
                    ></v-text-field>
                  </td>
                  <td>
                    <v-select
                      v-model="searchParams.destinationType"
                      :items="destinationTypeItems"
                      Destination
                      label="Destination"
                      @input="isTyping = true"
                      clearable
                      @click:clear="onClearDestinationClicked()"
                    ></v-select>
                  </td>
                  <td>
                    <v-text-field
                      v-model="searchParams.user"
                      type="text"
                      label="Créateur"
                      @input="isTyping = true"
                      clearable
                      @click:clear="onClearUserClicked()"
                    ></v-text-field>
                  </td>
                  <td>
                    <v-text-field
                      v-model="searchParams.difficulty"
                      type="number"
                      label="Difficulté"
                      @input="isTyping = true"
                      clearable
                      @click:clear="onClearDifficultyClicked()"
                    ></v-text-field>
                  </td>
                  <td>
                    <v-text-field
                      v-model="searchParams.intensity"
                      type="number"
                      label="Intensité"
                      @input="isTyping = true"
                      clearable
                      @click:clear="onClearIntensityClicked()"
                    ></v-text-field>
                  </td>
                  <td></td>
                </tr>
              </template>
              <!-- DDL Destination Type -->
              <template v-slot:[`item.destinationType`]="{ item }">
                {{ destinationTypeItems.find((e) => e.value === item.destinationType).text }}
              </template>
              <!-- Difficulty -->
              <template v-slot:[`item.difficulty`]="{ item }">
                <v-rating
                  color="#1B8A62"
                  background-color="#1B8A62"
                  readonly
                  v-model="item.difficulty"
                  empty-icon="mdi-hexagon-outline"
                  full-icon="mdi-hexagon"
                ></v-rating>
              </template>
              <!-- Intensity -->
              <template v-slot:[`item.intensity`]="{ item }">
                <v-rating color="#1B8A62" background-color="#1B8A62" readonly v-model="item.intensity" empty-icon="mdi-square-outline" full-icon="mdi-square"></v-rating>
              </template>
              <!-- Actions -->
              <template v-slot:[`item.actions`]="{ item }">
                <td v-if="canManageCycles">
                  <v-btn :to="{ name: 'GCE', params: { id: item.id } }" class="md-just-icon md-simple md-primary" v-if="canManageCycles" :disabled="!item.canManageCycle">
                    <v-icon color="#1B8A62">edit</v-icon>
                    <md-tooltip md-direction="top">Editer</md-tooltip>
                  </v-btn>
                </td>
                <td>
                  <v-btn :to="{ name: 'GCEViewer', params: { id: item.id } }" class="md-just-icon md-simple md-primary">
                    <v-icon color="#1B8A62">mdi-eye</v-icon>
                    <md-tooltip md-direction="top">Fiche</md-tooltip>
                  </v-btn>
                </td>
                <td v-if="canManageCycles">
                  <v-btn v-on:click="(e) => deleteCycle(e, item.id)" class="md-just-icon md-simple md-primary" v-if="canManageCycles" :disabled="!item.canManageCycle">
                    <v-icon color="#1B8A62">delete</v-icon>
                    <md-tooltip md-direction="top">Supprimer</md-tooltip>
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { getCyclesForCurrentUserAsync, deleteCycleAsync } from "@/api/cycleApi";
import { bus } from "@/main";
import PermissionsService from "@/services/PermissionsService";
import _ from "lodash";
import store from "@/store";
import AuthService from "@/services/AuthService";
import { DestinationType } from "@/models/enums";
import { CycleSortType } from "@/models/enums";

export default {
  name: "exercise-list",

  data() {
    return {
      authService: AuthService,
      // Search part ===
      searchParams: {
        id: null,
        title: "",
        destinationType: null,
        user: "",
        difficulty: null,
        intensity: null,
      },
      destinationTypeItems: [
        { text: "Transversal", value: DestinationType.PUBLIC },
        { text: "Spécifique", value: DestinationType.DISCIPLINE },
        { text: "Fédéral", value: DestinationType.FEDERAL },
        { text: "Entraîneur", value: DestinationType.COACH },
      ],
      isTyping: false,
      // Pagination part =======
      totalCycles: 0,
      options: {},
      page: 1,
      pageSize: 5,
      pageSizes: [5, 10, 20],
      userId: null,
      cycles: [],
      // Sort part ======
      sortBy: "id",
      sortDesc: true,
      // Others part ==
      selected: [],
      id: null,
      title: null,
      destinationType: null,
      user: null,
      difficulte: null,
      intensite: null,
    };
  },

  watch: {
    options: {
      handler() {
        // Refresh the cycle page with the provided parameters
        this.getCyclePage();
      },
      deep: true,
    },
    "searchParams.id": _.debounce(function () {
      this.isTyping = false;
    }, 1000),
    "searchParams.name": _.debounce(function () {
      this.isTyping = false;
    }, 1000),
    "searchParams.destinationType": _.debounce(function () {
      this.isTyping = false;
    }, 100),
    "searchParams.user": _.debounce(function () {
      this.isTyping = false;
    }, 1000),
    "searchParams.difficulty": _.debounce(function () {
      this.isTyping = false;
    }, 1000),
    "searchParams.intensity": _.debounce(function () {
      this.isTyping = false;
    }, 1000),
    isTyping: function (value) {
      if (!value) {
        this.onFiltersChanged();
        // Refresh the cycle page with the provided parameters
        this.getCyclePage();
      }
    },
  },

  computed: {
    canViewCycles() {
      // Can view own Cycles
      let canViewOwnCycles = PermissionsService.CyclesPermissionsService.canViewOwnCycles;
      // Can view all Cycles
      let canViewAllCycles = PermissionsService.CyclesPermissionsService.canViewAllCycles;
      return canViewOwnCycles || canViewAllCycles;
    },
    canManageCycles() {
      // Can manage own Cycles
      let canManageOwnCycles = PermissionsService.CyclesPermissionsService.canManageOwnCycles;
      // Can manage all Cycles
      let canManageAllCycles = PermissionsService.CyclesPermissionsService.canManageAllCycles;
      return canManageOwnCycles || canManageAllCycles;
    },
    headers() {
      return [
        {
          text: "id",
          value: "id",
        },
        {
          text: "Titre",
          value: "name",
        },
        {
          text: "Destination",
          value: "destinationType",
        },
        {
          text: "Créateur",
          value: "email",
        },
        {
          text: "Difficulté",
          value: "difficulty",
        },
        {
          text: "Intensité",
          value: "intensity",
        },
        { text: "Actions", value: "actions", sortable: false },
      ];
    },
  },

  mounted() {
    // Check if the user can see this page
    if (!this.canViewCycles) {
      store.dispatch("setSnackbar", {
        title: `Non Autorisé`,
        text: `Vous n'êtes pas autorisé à consulter cette ressource.`,
        status: "warning",
        timeout: 2000,
      });

      this.$router.replace("/");
    }
  },
  methods: {
    // Build the request params based on page parameters
    getRequestParams(userId, searchParams, page, pageSize, sortBy, sortDesc) {
      let params = {};
      if (userId) {
        params["userId"] = userId;
      }
      if (searchParams) {
        params["searchParams"] = searchParams;
      }
      if (page) {
        params["page"] = page;
      }
      if (pageSize) {
        params["size"] = pageSize;
      }
      if (sortBy) {
        params["sortBy"] = sortBy;
      }
      if (sortDesc) {
        params["sortDesc"] = sortDesc;
      }
      return params;
    },
    // Use request params to call REST API and get the paginated list of cycles
    retrieveCycles() {
      const userId = AuthService.userId;
      this.userId = userId;
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      this.page = page;
      this.pageSize = itemsPerPage;
      this.sortBy = sortBy;
      this.sortDesc = sortDesc;

      // Get the enum value of textual sort Exercice property in order to request the REST API
      var sortByEnum = this.convertCycleTextPropertiesIntoEnum(sortBy[0]);

      // Get the search params if exists
      let searchParams = {};
      if (this.searchParams) {
        searchParams = {
          id: this.searchParams.id,
          name: this.searchParams.name ? this.searchParams.name.trim().toLowerCase() : "",
          destinationType: this.searchParams.destinationType ? this.searchParams.destinationType : DestinationType.UNDEFINED,
          user: this.searchParams.user ? this.searchParams.user.trim().toLowerCase() : "",
          difficulty: this.searchParams.difficulty ? this.searchParams.difficulty : null,
          intensity: this.searchParams.intensity ? this.searchParams.intensity : null,
        };
      }

      // Build the parameters
      const params = this.getRequestParams(this.userId, searchParams, this.page, this.pageSize, sortByEnum, this.sortDesc);

      // Call the REST API service
      getCyclesForCurrentUserAsync(params)
        .then((response) => {
          const { cycleDatatableItems, totalCycles } = response;
          this.cycles = cycleDatatableItems;
          this.totalCycles = totalCycles;
        })
        .catch((e) => {
          store.dispatch("setSnackbar", {
            text: "La récupération des cycles n'a pas fonctionnée.",
            color: "error",
          });
        });
    },

    emitter(item) {
      bus.$emit("reference", item);
    },

    // Delete a Cycle
    async deleteCycle(e, id) {
      e.stopPropagation();

      if (confirm("Etes-vous sûr de vouloir supprimer ce cycle ?")) {
        var result = await deleteCycleAsync(id);

        // If the result is the id of the cycle the deletion worked
        if (result === id) {
          // Refresh the cycle page with the provided parameters
          this.getCyclePage();

          store.dispatch("setSnackbar", {
            title: "Cycle supprimé",
            text: "Le cycle a bien été supprimé.",
            status: "success",
            timeout: 2000,
          });
        }
      }
    },

    // Refresh the cycle page with the provided parameters
    getCyclePage() {
      this.retrieveCycles();
    },

    // Convert textual value of Cycle property into CycleSortType enum
    convertCycleTextPropertiesIntoEnum(textProp) {
      var result = CycleSortType.UNDEFINED;

      switch (textProp) {
        case "id":
          result = CycleSortType.ID;
          break;
        case "name":
          result = CycleSortType.NAME;
          break;
        case "destinationType":
          result = CycleSortType.DESTINATION;
          break;
        case "email":
          result = CycleSortType.EMAIL;
          break;
        case "difficulty":
          result = CycleSortType.DIFFICULTY;
          break;
        case "intensity":
          result = CycleSortType.INTENSITY;
          break;
        default:
          break;
      }

      return result;
    },

    // on filters changed
    onFiltersChanged() {
      // reset to page 1
      this.options.page = 1;
      this.page = 1;
    },

    // On click to clear the id search input
    onClearIdClicked() {
      this.searchParams.id = null;
      this.onFiltersChanged();
    },
    // On click to clear the title search input
    onClearTitleClicked() {
      this.searchParams.title = null;
      this.onFiltersChanged();
    },
    // On click to clear the destination search input
    onClearDestinationClicked() {
      this.searchParams.destinationType = null;
      this.onFiltersChanged();
    },
    // On click to clear the user search input
    onClearUserClicked() {
      this.searchParams.user = null;
      this.onFiltersChanged();
    },
    // On click to clear the difficulty search input
    onClearDifficultyClicked() {
      this.searchParams.difficulty = null;
      this.onFiltersChanged();
    },
    // On click to clear the intensity search input
    onClearIntensityClicked() {
      this.searchParams.intensity = null;
      this.onFiltersChanged();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .v-data-table__empty-wrapper {
  height: 120px;
}
</style>
